import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useCommunityDetailsViewModel = () => {
  const stateManager = useComponentState();
  const [community, setCommunity] = useState({});

  const isLoading = stateManager.isBusy();

  const getCommunityDetails = async (id) => {
    stateManager.run(async () => {
      const response = await homeService.communities.getById({
        id,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setCommunity(response.data);
      }
    });
  };

  const updateCommunity = (data) => {
    stateManager.run(async () => {
      const { id, modifiedOn } = community;
      const response = await homeService.communities.updateCommunity({
        id,
        data,
        modifiedOn,
        toastMessageConfig: {
          success: { text: `Community ${data.name} updated successfully.` },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getCommunityDetails(response.data.id);
      }
    });
  };

  return {
    community,
    isLoading,
    stateManager,
    getCommunityDetails,
    updateCommunity,
  };
};
